// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__dZCe5","label":"Labeled_label__2MovI","divider":"Labeled_divider__3Lr7h"};